export default __webpack_public_path__ + "static/media/MishtiTakyonDarkMiniBeta.f4ec94b6.png";